import { render } from "./AddAttachmentModal.vue?vue&type=template&id=ae744f7e"
import script from "./AddAttachmentModal.vue?vue&type=script&lang=js"
export * from "./AddAttachmentModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__